import React, { useEffect } from "react";
import { Field, useFormikContext } from "formik";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import { useStore } from "stores/connect";
import AWSRegionsStore, { AWSRegionsActions } from "archive/AWSRegionsStore";
const AWSRegionsFormGroup = () => {
  const { regions } = useStore(AWSRegionsStore);
  const {
    values: { settings },
    setFieldValue
  } = useFormikContext();
  const s3Settings = settings;
  useEffect(() => {
    AWSRegionsActions.getRegions();
    if (!s3Settings.aws_region) {
      setFieldValue("settings.aws_region", "");
      return () => {
        setFieldValue("settings.aws_region", void 0);
      };
    }
    return () => void 0;
  }, [setFieldValue]);
  return /* @__PURE__ */ React.createElement(Field, { name: "settings.aws_region" }, ({ meta }) => /* @__PURE__ */ React.createElement(Input, { id: "default-aws-region-select", label: "AWS Region", error: meta.error }, /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "awsRegion",
      name: "AWSRegion",
      placeholder: "Automatic",
      "aria-label": "Select AWS region",
      options: regions || [],
      onChange: (option) => {
        setFieldValue("settings.aws_region", option);
      },
      value: settings.aws_region
    }
  )));
};
export default AWSRegionsFormGroup;
